import { render, staticRenderFns } from "./orderSurchargeConfigDialog.vue?vue&type=template&id=d4129cc6&"
import script from "./orderSurchargeConfigDialog.vue?vue&type=script&lang=js&"
export * from "./orderSurchargeConfigDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports